<template>
    <v-container id="content-wrapper" :fluid="!showSidebar" class="content-wrapper pa-0">
        <v-row no-gutters>
            <v-col>
                <v-row justify-center align-center no-gutters>
                    <v-col
                        :ref="isAnchorTabs(section) ? 'stickyAnchor' : ''"
                        v-for="(section, key) in page.contentSections.content"
                        :key="key"
                        :cols="section.mobileWidth ? section.mobileWidth : 12"
                        :md="section.tabletWidth ? section.tabletWidth : 12"
                        :lg="section.desktopWidth ? section.desktopWidth : 12"
                        :class="`section-content ${section._type} ${
                            isAnchorTabs(section) ? 'stickyAnchorTabs' : ''
                        } ${isFixed && isAnchorTabs(section) ? 'fixed' : ''}`"
                        :style="calcInlineStyles(section)"
                    >
                        <ContentSection
                            :section="section"
                            :thumbnail="page.thumbnail"
                            :page="page"
                        />
                    </v-col>
                </v-row>
            </v-col>
            <v-col v-if="showSidebar" cols="12" md="4" lg="4">
                <PostsSidebar :page="page" />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import ContentSection from '~/components/ContentSection.vue'
import PostsSidebar from '~/components/PostsSidebar.vue'
export default {
    name: 'Content',
    components: {
        ContentSection,
        PostsSidebar,
    },
    props: {
        page: {
            type: Object,
            default: null,
        },
        template: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            windowTop: null,
            stickyTop: null,
            isFixed: false,
            initialTop: null,
        }
    },
    mounted() {
        window.addEventListener('scroll', this.onScroll)
        if (this.$refs['stickyAnchor'])
            this.initialTop = this.$refs['stickyAnchor'][0].offsetTop
    },
    computed: {
        showSidebar() {
            return (
                this.page.showSidebar &&
                this.page._type !== 'page' &&
                this.page._type !== 'topic' &&
                this.$vuetify.breakpoint.mdAndUp
            )
        },
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.onScroll)
    },
    methods: {
        isAnchorTabs(section) {
            return section._type === 'sectionAnchorTabs'
        },
        calcInlineStyles(section) {
            const rgba =
                section.bgColor && section.bgColor.rgb
                    ? section.bgColor.rgb
                    : null
            let styles = ''
            // styles += ''
            if (rgba) {
                styles += `background-color:rgba(${rgba.r},${rgba.g},${rgba.b},${rgba.a});`
            }
            return styles
        },
        onScroll() {
            if (this.$refs['stickyAnchor']) {
                this.windowTop = window.top.scrollY
                this.stickyTop = this.$refs['stickyAnchor'][0].offsetTop
                this.stickyTop = this.windowTop < 2460 ? this.initialTop : 112
                this.isFixed = this.windowTop > this.stickyTop ? true : false
                // console.log(this.windowTop)
                // console.log(this.stickyTop)
                // console.log(this.isFixed)
                // console.log(this.initialTop)
            }
        },
    },
}
</script>
<style scoped>
.fixed {
    position: fixed;
}
</style>
